export const breakpoints = {
    maxWidthXs: '625px',
    maxWidthSmall: '924px',
    minWidthMedium: '925px',
    maxWidthMedium: '1024px',
    minWidthLarge: '1025px',
  };